export type AirConfig = {
  googleMapsApiKey?: string
}
